module.exports = __webpack_public_path__ + "static/media/choose_left.2db7c04f.jpg";